/**
 * SHER-1033 / SHER-1034 — one place for the Total row of both Finance analytics tables.
 *
 * The sum is over every filtered record the table holds, not the current page. The print
 * path must call the same helpers so the exported Total cannot drift from the screen.
 */

export interface CategoryBillingNumericRow {
    count: number;
    totalBilled: number;
    totalPaid: number;
    totalPending: number;
    totalDiscount: number;
    totalExternalPaymentPending: number;
    totalExternalPaymentPaid: number;
}

export interface CategoryBillingTotalRow extends CategoryBillingNumericRow {
    category: string;
}

export function sumCategoryBillingRows(
    rows: CategoryBillingNumericRow[],
    label: string = "Total",
): CategoryBillingTotalRow {
    return rows.reduce(
        (total, row) => ({
            category: label,
            count: total.count + (row.count || 0),
            totalBilled: total.totalBilled + (row.totalBilled || 0),
            totalPaid: total.totalPaid + (row.totalPaid || 0),
            totalPending: total.totalPending + (row.totalPending || 0),
            totalDiscount: total.totalDiscount + (row.totalDiscount || 0),
            totalExternalPaymentPending:
                total.totalExternalPaymentPending + (row.totalExternalPaymentPending || 0),
            totalExternalPaymentPaid:
                total.totalExternalPaymentPaid + (row.totalExternalPaymentPaid || 0),
        }),
        {
            category: label,
            count: 0,
            totalBilled: 0,
            totalPaid: 0,
            totalPending: 0,
            totalDiscount: 0,
            totalExternalPaymentPending: 0,
            totalExternalPaymentPaid: 0,
        },
    );
}

export function sumPatientCategoryAmount(
    rows: { totalPaidInPeriod?: number | null }[],
): number {
    return rows.reduce((sum, row) => sum + (Number(row.totalPaidInPeriod) || 0), 0);
}
